import TitleBarIcon from './TitleBarIcon';

export default TitleBarIcon;
